import { lazy, Suspense } from 'react';

import { cn } from '../lib/cn';
import type { ICodeViewProps, TCodeLanguage } from './code-view-editor';

export type { ICodeViewProps, TCodeLanguage } from './code-view-editor';

/** A body is JSON when it parses as JSON; anything else (form, XML, plain) is shown as text. */
export const languageOfText = (text: string): TCodeLanguage => {
  if (!/^\s*[[{]/.test(text)) return 'text';
  try {
    JSON.parse(text);
    return 'json';
  } catch {
    return 'text';
  }
};

// CodeMirror is ~150 kB gzipped; loaded on first use so /login and every screen without a
// code block never download it. Only the type crosses this import, so the module stays split.
const Editor = lazy(() =>
  import('./code-view-editor').then((module) => ({ default: module.CodeViewEditor })),
);

export const CodeView = (props: ICodeViewProps) => (
  <Suspense
    fallback={
      <pre
        aria-busy
        className={cn(
          'max-h-code-view-max overflow-auto bg-surface-sunken px-3 py-3 font-mono text-data whitespace-pre-wrap text-primary',
          props.className,
        )}
      >
        {props.value}
      </pre>
    }
  >
    <Editor {...props} />
  </Suspense>
);
